<template>
  <div
    v-if="isLoading"
    class="d-flex justify-center align-center"
    style="height: 100vh; width: 100vw;"
  >
    <v-progress-circular
      indeterminate
      color="#2661FF"
      size="80"
    ></v-progress-circular>
  </div>
  <div v-else>
    <v-row no-gutters>
      <v-col cols="12">
        <BaseToolbar
          :title="$t('pricing_model.view.pricing_model.title').toUpperCase()"
          type-title="icon"
          icon="visibility"
          :button-save="false"
          @close="closeViewPricingModel"
        >
        </BaseToolbar>
      </v-col>
    </v-row>
    <!------------------------------------------>
    <!-- PROMOTIONAL CODES --------------------->
    <!------------------------------------------>
    <v-row>
      <v-col cols="12" class="px-8">
        <ManagePromotionalCodes
          :table="promoCodesTable"
          @fetchPromotionalCodes="fetchPromotionalCodes"
          @table-pagination="promoCodesTable.pagination = $event"
        />
      </v-col>
    </v-row>
    <!------------------------------------------>
    <!-- PLAN DETAILS -------------------------->
    <!------------------------------------------>
    <v-row class="pa-8">
      <v-col cols="12">
        <v-card class="rounded-lg pa-4" flat>
          <v-card-title class="justify-center">
            {{ $t('pricing_model.view.pricing_model.title') }}
          </v-card-title>
          <v-card-text class="text-center grey--text text--darken-3 mb-2">
            {{ $t('pricing_model.view.pricing_model.description') }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <!------------------------------------------>
              <!-- NAME ----------------------------->
              <!------------------------------------------>
              <v-col cols="12" md="6">
                <!-- <h3 class="body-2 mb-2 ml-1">
                  {{ $t("pricing_model.view.pricing_model.name") }}
                </h3> -->
                <v-text-field
                  :value="localPricingModel.display_name"
                  :label="$t('pricing_model.view.pricing_model.name')"
                  class="rounded-lg"
                  hide-details
                  outlined
                  readonly
                >
                </v-text-field>
              </v-col>
              <!------------------------------------------>
              <!-- ID ----------------------------->
              <!------------------------------------------>
              <v-col cols="12" md="6">
                <!-- <h3 class="body-2 mb-2 ml-1">
                  {{ $t("pricing_model.view.pricing_model.id") }}
                </h3> -->
                <v-text-field
                  :value="localPricingModel.id"
                  disabled
                  label="ID"
                  class="rounded-lg"
                  hide-details
                  outlined
                  readonly
                >
                </v-text-field>
              </v-col>
              <!------------------------------------------>
              <!-- DESCRIPTION ----------------------------->
              <!------------------------------------------>
              <v-col cols="12">
                <!-- <h3 class="body-2 mb-2 ml-1">
                  {{
                    $t(
                      "pricing_model.view.pricing_model.description_input.title"
                    )
                  }}
                </h3> -->
                <v-text-field
                  :value="localPricingModel.description"
                  :label="
                    $t(
                      'pricing_model.view.pricing_model.description_input.label'
                    )
                  "
                  class="rounded-lg"
                  hide-details
                  outlined
                  readonly
                >
                </v-text-field>
              </v-col>
              <!------------------------------------------>
              <!-- STATUS ----------------------------->
              <!------------------------------------------>
              <v-col cols="12" md="6">
                <!-- <h3 class="body-2 mb-2 ml-1">
                  {{ $t("pricing_model.view.pricing_model.status") }}
                </h3> -->
                <v-text-field
                  :value="statusText"
                  :items="status"
                  :label="$t('pricing_model.view.pricing_model.status')"
                  class="rounded-lg"
                  hide-details
                  outlined
                  readonly
                >
                </v-text-field>
              </v-col>
              <!------------------------------------------>
              <!-- FREQUENCY ----------------------------->
              <!------------------------------------------>
              <v-col cols="12" md="6">
                <!-- <h3 class="body-2 mb-2 ml-1">
                  {{ $t("pricing_model.view.pricing_model.frequency") }}
                </h3> -->
                <v-text-field
                  :value="frequencyText"
                  :label="$t('pricing_model.view.pricing_model.frequency')"
                  class="rounded-lg"
                  hide-details
                  outlined
                  readonly
                >
                </v-text-field>
              </v-col>
              <!------------------------------------------>
              <!-- CURRENCIES ----------------------------->
              <!------------------------------------------>
              <v-col cols="12">
                <h3 class="body-2 mb-2 ml-1">
                  {{ $t('pricing_model.view.pricing_model.currencies') }}
                </h3>
                <v-row>
                  <v-col
                    v-for="(currency, index) in localPricingModel.currencies"
                    v-bind:key="index"
                    cols="12"
                    md="4"
                    class="mb-2"
                  >
                    <v-card
                      class="rounded-r-lg"
                      style="border-left: 4px solid #2661ff !important;"
                    >
                      <v-card-title
                        class="subtitle-1 grey--text text--darken-3"
                      >
                        <v-icon class="mr-2" color="#2661FF">payments</v-icon>
                        <span>
                          {{ currency.name }}
                          ({{ currency.code }})
                        </span>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="py-2 px-8" no-gutters>
      <v-col cols="12">
        <!------------------------------------------>
        <!-- PLANS --------------------------------->
        <!------------------------------------------>
        <template>
          <v-expansion-panels>
            <ViewPlan
              v-for="(plan, i) in localPricingModel.plans"
              :key="i"
              :plan="plan"
              class="rounded-lg my-2"
            />
          </v-expansion-panels>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar'
import ViewPlan from '@/components/PricingModels/View/ViewPlan'
import ManagePromotionalCodes from '../../Addon/PromotionalCodes/ManagePromotionalCodes.vue'

export default {
  name: 'PricingModelView',
  components: {
    ViewPlan,
    BaseToolbar,
    ManagePromotionalCodes
  },
  data() {
    return {
      isLoading: false,
      promoCodesTable: {
        loading: false,
        items: [],
        total: 0,
        filters: {
          search: ''
        },
        pagination: {
          sortBy: ['id'],
          sortDesc: [false],
          page: 1,
          itemsPerPage: 10
        },
        headers: [
          {
            text: 'ID',
            align: 'center',
            sortable: true,
            value: 'id',
            class: 'text-no-wrap header-color'
          },
          {
            text: this.$t('common.name'),
            align: 'center',
            sortable: true,
            value: 'name',
            class: 'text-no-wrap header-color'
          },
          {
            text: this.$t('pricing_model.promotional_codes.table.headers.code'),
            align: 'center',
            sortable: true,
            value: 'code',
            class: 'text-no-wrap header-color'
          },
          {
            text: this.$t(
              'pricing_model.promotional_codes.table.headers.pricing_model'
            ),
            align: 'center',
            sortable: true,
            value: 'pricingModel.display_name',
            class: 'text-no-wrap header-color'
          },
          {
            text: this.$t(
              'pricing_model.promotional_codes.table.headers.expiration_date'
            ),
            align: 'center',
            sortable: false,
            value: 'expiration_date',
            class: 'text-no-wrap header-color'
          },
          {
            text: this.$t(
              'pricing_model.promotional_codes.table.headers.status'
            ),
            align: 'center',
            sortable: false,
            value: 'status',
            class: 'text-no-wrap header-color'
          },
          {
            text: this.$t(
              'pricing_model.promotional_codes.table.headers.actions'
            ),
            align: 'center',
            sortable: false,
            value: 'actions',
            class: 'text-no-wrap header-color'
          }
        ]
      },
      status: [
        {
          text: this.$t('pricing_model.view.pricing_model.statuses.active'),
          value: true
        },
        {
          text: this.$t('pricing_model.view.pricing_model.statuses.disabled'),
          value: false
        }
      ],
      frequencies: [
        {
          text: this.$t('pricing_model.view.pricing_model.frequencies.monthly'),
          value: 1
        },
        {
          text: this.$t('pricing_model.view.pricing_model.frequencies.yearly'),
          value: 2
        },
        {
          text: this.$t(
            'pricing_model.view.pricing_model.frequencies.monthly_and_yearly'
          ),
          value: 3
        }
      ],
      localPricingModel: {}
    }
  },
  async created() {
    this.localPricingModel = { ...this.pricingModel }
    await this.fetchPromotionalCodes()
  },
  watch: {
    'promoCodesTable.pagination': {
      async handler() {
        await this.fetchPromotionalCodes()
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      promotionalCodes: state => state.pricingModels.promotionalCodes,
      pricingModel: ({ pricingModels: { pricingModel } }) => pricingModel,
      promotionalCodesTotal: state => state.pricingModels.promotionalCodesTotal
    }),
    frequencyText() {
      return this.localPricingModel.frequency === 1
        ? this.$t('pricing_model.view.pricing_model.frequencies.monthly')
        : this.localPricingModel.frequency === 2
        ? this.$t('pricing_model.view.pricing_model.frequencies.yearly')
        : this.$t(
            'pricing_model.view.pricing_model.frequencies.monthly_and_yearly'
          )
    },
    statusText() {
      return this.localPricingModel.status === 1
        ? this.$t('pricing_model.view.pricing_model.statuses.active')
        : this.$t('pricing_model.view.pricing_model.statuses.disabled')
    }
  },
  methods: {
    ...mapActions({
      getPromotionalCodes: 'pricingModels/getPromotionalCodes',
      removePromotionalCode: 'pricingModels/removePromotionalCode'
    }),
    ...mapMutations({
      setPricingModelDrawerView: 'pricingModels/setPricingModelDrawerView',
      resetPricingModel: 'pricingModels/resetPricingModel'
    }),
    async fetchPromotionalCodes() {
      const { promoCodesTable } = this
      const { search } = promoCodesTable.filters
      const { page, itemsPerPage } = promoCodesTable.pagination
      let { sortBy, sortDesc = false } = promoCodesTable.pagination

      promoCodesTable.loading = true

      if (Array.isArray(sortBy)) {
        ;[sortBy] = sortBy
      }
      if (Array.isArray(sortDesc)) {
        ;[sortDesc] = sortDesc
      }

      const payload = {
        page,
        sortBy,
        search,
        sortDesc,
        itemsPerPage,
        pricingModelId: this.localPricingModel.id
      }

      await this.getPromotionalCodes(payload)

      this.promoCodesTable.items = this.promotionalCodes
      this.promoCodesTable.total = parseInt(this.promotionalCodesTotal, 10)

      promoCodesTable.loading = false
    },
    closeViewPricingModel() {
      this.setPricingModelDrawerView(false)
      this.resetPricingModel()
    }
  }
}
</script>

<style lang="scss" scoped></style>
